export default __webpack_public_path__ + "static/media/24.7g1881vb.376ea24f.jpeg";